import { SegmentationListingPageProps } from '@/components/pages/segmentationListings/segmentationListingPageProps';

export const narrowSeoNavigationLinkSection = (
  seoNavigationLinkSection: SegmentationListingPageProps['pageData']['seoNavigationLinkSection']
) => {
  if (seoNavigationLinkSection === null) return null;

  if (seoNavigationLinkSection.__typename === 'SEONavigationLinkSectionSuccess') {
    return seoNavigationLinkSection;
  }

  return null;
};
